import * as React from "react";
import { forwardRef } from "react";
const SvgPlayOutline = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" ref={ref} {...props}><path fill="currentColor" fillRule="evenodd" d="m4 11.764 6.78-3.39L4 4.463v7.3ZM2 2.73v10.651a1 1 0 0 0 1.447.894l9.89-4.945a1 1 0 0 0 .053-1.76L3.5 1.865a1 1 0 0 0-1.5.866Z" clipRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgPlayOutline);
export default ForwardRef;